import { render, staticRenderFns } from "./activityNewContent.vue?vue&type=template&id=724189ee"
import script from "./activityNewContent.vue?vue&type=script&lang=js"
export * from "./activityNewContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports